import Vue from 'vue';
// @ts-ignore
import AOS from 'aos';
// @ts-ignore
import * as Rellax from "rellax";

import WorkbenchLanding from "Components/WorkbenchLanding/WorkbenchLanding";
// @ts-ignore
import * as enquire from 'enquire.js';

namespace NHW.controllers.workbenchLanding {
	function initializeWorkbenchLanding() {
		new Vue({
			created () {
				AOS.init({startEvent: 'load'});
				testFirstCookie();
			},
			render: h => h(WorkbenchLanding)
		}).$mount('#workbenchLanding');
	}


	function GetCookie(name) {
		var arg=name+"=";
		var alen=arg.length;
		var clen=document.cookie.length;
		var i=0;
		while (i<clen) {
			var j=i+alen;
			if (document.cookie.substring(i,j)==arg)
				return "here";
			i=document.cookie.indexOf(" ",i)+1;
			if (i==0) break;
		}
		return null;
	}


	function swapCreatorsCornerVideoSrc() {
		let $video:HTMLVideoElement = document.querySelector('.js-cc-video')

		if(!$video) {
			return;
		}
		let mobileSrc = $video.getAttribute('data-mobilesrc');
		let desktopSrc = $video.getAttribute('data-desktopsrc');

		enquire.register("screen and (max-width:767px)", {
			match: function() {
				$('.js-cc-video').attr('src', mobileSrc);
				$video.load();
			},
			unmatch: function() {
				$('.js-cc-video').attr('src', desktopSrc);
				$video.load();
			},
		});
	}

	function testFirstCookie(){
		window.onbeforeunload = function () {
			window.scrollTo(0, 0);
		}
		let visit=GetCookie("firstTimeVisit");
		if (visit==null){
			var expire=new Date();
			expire=new Date(expire.getTime()+7776000000);
			document.cookie="firstTimeVisit=here; expires="+expire + ";path=/";
			let videoWrap = $("#videoWrap");
			videoWrap.addClass('state-visible');

			if (videoWrap)
			{
				//trigger animation to hide at end of video
				document.getElementById('workbenchVideo').addEventListener('ended',function(){
					videoWrap.slideUp(500);
					videoWrap.removeClass('state-visible');
					videoWrap.removeAttr('style');
					AOS.refresh();
				});
				//trigger animation to hide on skip click
				document.getElementById('js-skip-video').addEventListener('click',function(){
					videoWrap.slideUp(500);
					videoWrap.removeClass('state-visible');
					videoWrap.removeAttr('style');
					AOS.refresh();
				});

				document.getElementById('workbenchVideo').addEventListener('playing', function() {
					window.scrollTo(0, 0);
				}, false);
			}
			swapCreatorsCornerVideoSrc();
		}
	}

	export function init() {
		if(document.querySelector('.js-component')) {
			initializeWorkbenchLanding();
		}
	}
}

NHW.controllers.workbenchLanding.init();
